import { Pagination, Select, SelectItem } from "@heroui/react";

export function BottomContent({
  totalItemSize,
  currentPage,
  itemsPerPage,
  setCurrentPage,
  setItemsPerPage,
}: {
  totalItemSize: number;
  currentPage: number;
  itemsPerPage: number;
  setCurrentPage: (page: number) => void;
  setItemsPerPage: (pageSize: number) => void;
}) {
  const pages = Math.ceil(totalItemSize / itemsPerPage);
  const pageStartIndex = (currentPage - 1) * itemsPerPage + 1;
  const pageEndIndex = Math.min(currentPage * itemsPerPage, totalItemSize);

  // hide pagination if there are no items
  if (totalItemSize === 0) {
    return null;
  }

  return (
    <div className="flex w-full justify-between items-center">
      <Select
        variant="flat"
        radius="full"
        label="Items per page"
        labelPlacement="outside-left"
        fullWidth={false}
        classNames={{
          base: "w-auto items-center",
          mainWrapper: "w-20",
          trigger: "data-[hover=true]:bg-[var(--turnstile-input-hover-color)]",
        }}
        selectedKeys={[String(itemsPerPage)]}
        onChange={(e) => setItemsPerPage(Number(e.target.value))}
      >
        <SelectItem key="10">10</SelectItem>
        <SelectItem key="15">15</SelectItem>
      </Select>
      <p>
        Showing {pageStartIndex}-{pageEndIndex} of {totalItemSize} items
      </p>
      <Pagination
        variant="bordered"
        color="default"
        radius="full"
        showControls
        page={currentPage}
        total={pages}
        onChange={setCurrentPage}
      />
    </div>
  );
}
